import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  OutlookMailboxValidationResponseDataSchema,
  ValidateOutlookMailboxSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof OutlookMailboxValidationResponseDataSchema>>

export function useValidateOutlookMailboxMutation() {
  return useMutation({
    mutationFn: async (data: z.input<typeof ValidateOutlookMailboxSchema>) => {
      const response = await axios.post<Response>(`/integrations/outlook/mailboxes/validate`, data)

      return response.data.data
    },
  })
}
